import {
  ClassifierType,
  ObjectDetectorType,
  PretrainedModelName,
} from '@tabeeb/contracts/microservices/swagger-ai-service'

export const PretrainedModelNameDisplayName = {
  [PretrainedModelName.CLIP]: 'CLIP',
  [PretrainedModelName.SimCLR]: 'SimCLR',
  [PretrainedModelName.DinoV2Base]: 'Dinov2 base',
  [PretrainedModelName.VitSmall]: 'Vit small',
  [PretrainedModelName.ResnetRS50]: 'Resnet-RS 50',
  [PretrainedModelName.SwinTransformersBase]: 'Swin transformers base',
  [PretrainedModelName.ConvnextTiny]: 'Convnext tiny',
}

export const ClassifierTypeDisplayName = {
  [ClassifierType.MLP]: 'MLP',
  [ClassifierType.LogisticRegression]: 'Logistic regression',
}

export const ObjectDetectorTypeDisplayName = {
  [ObjectDetectorType.YoloXSmall]: 'YOLOX Small',
  [ObjectDetectorType.YoloXMedium]: 'YOLOX Medium',
  [ObjectDetectorType.YoloXLarge]: 'YOLOX Large',
  [ObjectDetectorType.FasterRCNN50]: 'Faster R-CNN 50',
  [ObjectDetectorType.FasterRCNN101]: 'Faster R-CNN 101',
  [ObjectDetectorType.FasterRCNN101X]: 'Faster R-CNN 101X',
  [ObjectDetectorType.MaskRCNN50]: 'Mask R-CNN 50',
  [ObjectDetectorType.MaskRCNN101]: 'Mask R-CNN 101',
  [ObjectDetectorType.MaskRCNN101X]: 'Mask R-CNN 101X',
  [ObjectDetectorType.CascadeMaskRCNN50]: 'Cascade Mask R-CNN 50',
}
